import React from "react";
import Typography from "./shared/Typography";
import AdSenseAd from "./AdSenseAd";
import { colors } from "../constants/colors";

function Privacy() {
  const containerStyle = {
    minHeight: "100vh",
    backgroundColor: colors.extraLightGray,
    paddingTop: "2rem",
    paddingBottom: "4rem",
  };

  const contentStyle = {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const headerCardStyle = {
    backgroundColor: colors.white,
    borderRadius: "20px",
    padding: "3rem 2rem",
    marginBottom: "2rem",
    boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
    textAlign: "center",
    background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.lightBlue} 100%)`,
  };

  const sectionCardStyle = {
    backgroundColor: colors.white,
    borderRadius: "16px",
    padding: "2rem",
    marginBottom: "1.5rem",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    border: `1px solid ${colors.doubleExtraLightGray}`,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  };

  const sectionCardHoverStyle = {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
  };

  const listStyle = {
    margin: "1rem 0",
    paddingLeft: "0",
    listStyle: "none",
  };

  const listItemStyle = {
    backgroundColor: colors.lightBlue,
    margin: "0.5rem 0",
    padding: "0.75rem 1rem",
    borderRadius: "8px",
    borderLeft: `4px solid ${colors.darkGreen}`,
    transition: "all 0.2s ease",
  };

  const footerCardStyle = {
    backgroundColor: colors.darkBlue,
    color: colors.white,
    borderRadius: "16px",
    padding: "2rem",
    marginTop: "3rem",
    textAlign: "center",
    background: `linear-gradient(135deg, ${colors.darkBlue} 0%, ${colors.darkGreen} 100%)`,
  };

  const contactCardStyle = {
    backgroundColor: colors.lightGreen,
    padding: "1.5rem",
    borderRadius: "12px",
    border: `2px solid ${colors.darkGreen}`,
    marginBottom: "1rem",
  };

  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = sectionCardHoverStyle.transform;
    e.currentTarget.style.boxShadow = sectionCardHoverStyle.boxShadow;
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = sectionCardStyle.boxShadow;
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        {/* Header Section */}
        <div style={headerCardStyle}>
          <Typography
            variant="h1"
            style={{
              marginBottom: "1rem",
              color: colors.darkBlue,
              fontSize: "clamp(2rem, 5vw, 3rem)",
            }}
          >
            Privacy Policy
          </Typography>
          <Typography
            variant="body"
            style={{
              color: colors.darkGray,
              fontWeight: "600",
              fontSize: "1.1rem",
            }}
          >
            Last updated: August 15, 2025
          </Typography>
          <Typography
            variant="body"
            style={{
              marginTop: "1rem",
              color: colors.darkGray,
              fontSize: "1rem",
              maxWidth: "600px",
              margin: "1rem auto 0",
              lineHeight: "1.6",
            }}
          >
            At Nutriplate, we take your privacy seriously. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your
            information when you use our nutrition tracking application.
          </Typography>
        </div>

        {/* Information We Collect */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Information We Collect
          </Typography>

          <Typography
            variant="h3"
            style={{
              marginTop: "1.5rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Personal Information
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            We may collect personal information that you voluntarily provide to
            us when you:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>Create an account</li>
            <li style={listItemStyle}>Log your meals and nutrition data</li>
            <li style={listItemStyle}>Contact us for support</li>
          </ul>

          <Typography
            variant="h3"
            style={{
              marginTop: "2rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Subscription and Payment Data
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            For premium subscription users, we collect and process:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>
              Subscription status and billing information through App Store and
              RevenueCat
            </li>
            <li style={listItemStyle}>
              Usage analytics for premium features with enhanced limits
            </li>
            <li style={listItemStyle}>
              Payment transaction records (processed by Apple, managed by
              RevenueCat)
            </li>
            <li style={listItemStyle}>
              Cross-platform subscription synchronization data via RevenueCat
            </li>
          </ul>

          <Typography
            variant="h3"
            style={{
              marginTop: "2rem",
              marginBottom: "0.75rem",
              color: colors.darkGreen,
            }}
          >
            Usage Data
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            We automatically collect certain information when you access and use
            Nutriplate, including:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>Device information and identifiers</li>
            <li style={listItemStyle}>Usage patterns and preferences</li>
            <li style={listItemStyle}>Log data and analytics</li>
          </ul>
        </div>

        {/* Advertisement */}
        <div
          style={{
            padding: "2rem 0",
            textAlign: "center",
          }}
        >
          <AdSenseAd
            adSlot="1234567893"
            style={{
              margin: "0 auto",
              maxWidth: "728px",
            }}
          />
        </div>

        {/* How We Use Your Information */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            How We Use Your Information
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            We use the information we collect to:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>
              Manage subscription status and premium feature access
            </li>
            <li style={listItemStyle}>
              Provide and maintain our nutrition tracking services
            </li>
            <li style={listItemStyle}>
              Personalize your experience and recommendations
            </li>
            <li style={listItemStyle}>
              Communicate with you about updates and features
            </li>
            <li style={listItemStyle}>
              Improve our app and develop new features
            </li>
            <li style={listItemStyle}>Ensure security and prevent fraud</li>
          </ul>
        </div>

        {/* Two-Column Section for Information Sharing and Data Security */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
            gap: "1.5rem",
            marginBottom: "1.5rem",
          }}
        >
          {/* Information Sharing */}
          <div
            style={sectionCardStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Typography
              variant="h2"
              style={{
                marginBottom: "1.5rem",
                color: colors.darkBlue,
                borderBottom: `2px solid ${colors.lightGreen}`,
                paddingBottom: "0.5rem",
                fontSize: "1.5rem",
              }}
            >
              Information Sharing
            </Typography>
            <Typography
              variant="body"
              style={{ marginBottom: "1rem", lineHeight: "1.7" }}
            >
              We do not sell, trade, or otherwise transfer your personal
              information to third parties except:
            </Typography>
            <ul style={listStyle}>
              <li style={listItemStyle}>With your explicit consent</li>
              <li style={listItemStyle}>To comply with legal obligations</li>
              <li style={listItemStyle}>To protect our rights and safety</li>
              <li style={listItemStyle}>
                With trusted service providers who assist in our operations
                (such as RevenueCat for subscription management)
              </li>
            </ul>
          </div>

          {/* Data Security */}
          <div
            style={sectionCardStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Typography
              variant="h2"
              style={{
                marginBottom: "1.5rem",
                color: colors.darkBlue,
                borderBottom: `2px solid ${colors.lightGreen}`,
                paddingBottom: "0.5rem",
                fontSize: "1.5rem",
              }}
            >
              Data Security
            </Typography>
            <Typography
              variant="body"
              style={{ marginBottom: "1rem", lineHeight: "1.7" }}
            >
              We implement appropriate security measures to protect your
              personal information against unauthorized access, alteration,
              disclosure, or destruction.
            </Typography>
            <Typography
              variant="body"
              style={{
                lineHeight: "1.7",
                fontSize: "0.9rem",
                backgroundColor: colors.lightBlue,
                padding: "1rem",
                borderRadius: "8px",
                borderLeft: `4px solid ${colors.darkGreen}`,
              }}
            >
              <strong>Important:</strong> However, no method of transmission
              over the internet is 100% secure.
            </Typography>
          </div>
        </div>

        {/* Advertisement */}
        <div
          style={{
            padding: "2rem 0",
            textAlign: "center",
          }}
        >
          <AdSenseAd
            adSlot="1234567894"
            style={{
              margin: "0 auto",
              maxWidth: "728px",
            }}
          />
        </div>

        {/* Your Rights */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Your Rights
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            You have the right to:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>
              Access and update your personal information
            </li>
            <li style={listItemStyle}>
              Delete your account and associated data
            </li>
            <li style={listItemStyle}>Opt-out of marketing communications</li>
            <li style={listItemStyle}>Request data portability</li>
            <li style={listItemStyle}>Withdraw consent where applicable</li>
          </ul>
        </div>

        {/* Data Retention */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Data Retention
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "1rem", lineHeight: "1.7" }}
          >
            We retain your personal information for different periods depending
            on the type of data:
          </Typography>
          <ul style={listStyle}>
            <li style={listItemStyle}>
              <strong>Account Data:</strong> Retained while your account is
              active and for 30 days after deletion
            </li>
            <li style={listItemStyle}>
              <strong>Subscription Data:</strong> Retained for the duration of
              your subscription and 7 years thereafter for legal compliance
            </li>
            <li style={listItemStyle}>
              <strong>Health Data:</strong> Deleted immediately upon account
              deletion or upon your request
            </li>
            <li style={listItemStyle}>
              <strong>Usage Analytics:</strong> Anonymized data may be retained
              indefinitely for service improvement
            </li>
          </ul>
        </div>

        {/* Additional Policies Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
            gap: "1.5rem",
            marginBottom: "1.5rem",
          }}
        >
          {/* Cookies and Tracking */}
          <div
            style={sectionCardStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Typography
              variant="h2"
              style={{
                marginBottom: "1.5rem",
                color: colors.darkBlue,
                borderBottom: `2px solid ${colors.lightGreen}`,
                paddingBottom: "0.5rem",
                fontSize: "1.5rem",
              }}
            >
              Cookies & Tracking
            </Typography>
            <Typography
              variant="body"
              style={{ marginBottom: "0", lineHeight: "1.7" }}
            >
              Nutriplate uses cookies and similar tracking technologies to
              enhance your experience, analyze usage patterns, and provide
              personalized content. You can control cookie preferences through
              your browser settings.
            </Typography>
          </div>

          {/* Children's Privacy */}
          <div
            style={sectionCardStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Typography
              variant="h2"
              style={{
                marginBottom: "1.5rem",
                color: colors.darkBlue,
                borderBottom: `2px solid ${colors.lightGreen}`,
                paddingBottom: "0.5rem",
                fontSize: "1.5rem",
              }}
            >
              Children's Privacy
            </Typography>
            <Typography
              variant="body"
              style={{ marginBottom: "0", lineHeight: "1.7" }}
            >
              Nutriplate is not intended for children under 13. We do not
              knowingly collect personal information from children under 13. If
              you believe we have collected such information, please contact us
              immediately.
            </Typography>
          </div>
        </div>

        {/* Changes to This Policy */}
        <div
          style={sectionCardStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.darkBlue,
              borderBottom: `2px solid ${colors.lightGreen}`,
              paddingBottom: "0.5rem",
            }}
          >
            Changes to This Policy
          </Typography>
          <Typography
            variant="body"
            style={{ marginBottom: "0", lineHeight: "1.7" }}
          >
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page
            and updating the "Last updated" date.
          </Typography>
        </div>

        {/* Footer with Contact Information */}
        <div style={footerCardStyle}>
          <Typography
            variant="h2"
            style={{
              marginBottom: "1.5rem",
              color: colors.white,
              fontSize: "1.5rem",
            }}
          >
            Contact Us & Legal Information
          </Typography>

          <div style={contactCardStyle}>
            <Typography
              variant="body"
              style={{
                marginBottom: "1rem",
                color: colors.darkGreen,
                lineHeight: "1.7",
                textAlign: "center",
                fontWeight: "600",
              }}
            >
              This Privacy Policy is accessible at all times within the
              NutriPlate app. For subscription-related inquiries, please use
              your App Store account.
            </Typography>
            <Typography
              variant="body"
              style={{
                marginBottom: "1rem",
                color: colors.darkGreen,
                lineHeight: "1.7",
                textAlign: "center",
              }}
            >
              If you have any questions about this Privacy Policy or our
              practices, please contact us at:
            </Typography>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "2rem",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="body"
                style={{
                  color: colors.darkGreen,
                  fontWeight: "bold",
                }}
              >
                📧 support@nutriplate.com
              </Typography>
              <Typography
                variant="body"
                style={{
                  color: colors.darkGreen,
                  fontWeight: "bold",
                }}
              >
                📞 +46728570590
              </Typography>
            </div>
          </div>

          {/* Company Information */}
          <div
            style={{
              backgroundColor: colors.white,
              padding: "1.5rem",
              borderRadius: "12px",
              border: `2px solid ${colors.lightGreen}`,
              marginTop: "1.5rem",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body"
              style={{
                color: colors.darkBlue,
                fontWeight: "600",
                marginBottom: "0.5rem",
                fontSize: "1rem",
              }}
            >
              NutriPlate is developed and operated by
            </Typography>
            <Typography
              variant="body"
              style={{
                color: colors.darkGreen,
                fontWeight: "bold",
                fontSize: "1.1rem",
                marginBottom: "0.5rem",
              }}
            >
              RayaTech AB
            </Typography>
            <Typography
              variant="body"
              style={{
                color: colors.darkGray,
                fontSize: "0.9rem",
                marginBottom: "0.3rem",
              }}
            >
              Organization Number: 559546-6904
            </Typography>
            <Typography
              variant="body"
              style={{
                color: colors.darkGray,
                fontSize: "0.9rem",
              }}
            >
              Stockholm, Sweden
            </Typography>
          </div>

          <Typography
            variant="body"
            style={{
              color: colors.white,
              textAlign: "center",
              marginTop: "1rem",
              opacity: "0.9",
              lineHeight: "1.6",
            }}
          >
            Your privacy is important to us. We are committed to protecting your
            personal information and being transparent about our data practices.
            This Privacy Policy is always accessible within the app and
            constitutes our functional privacy policy link as required by App
            Store guidelines.
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
